<template>
  <VSnapNav
    :value="sportId"
    class="sports-navs"
    inkbar
    :force-bar-width="42"
    bar-height="4px"
    :styleBar="{
      bottom: '6px'
    }"
  >
    <template v-for="item in sportList">
      <VSnapNavItem
        :key="item.sportId"
        class="sports-nav-item"
        :name="item.sportId"
        @click="handleClick(item.sportId, item.sportName)"
      >
        {{ item.sportName }}
      </VSnapNavItem>
    </template>
  </VSnapNav>
</template>

<script>
import VSnapNav from 'fe-vui/snapNav'
import VSnapNavItem from 'fe-vui/snapNavItem'

export default {
  name: 'SportsNav',
  components: {
    VSnapNav,
    VSnapNavItem
  },
  model: {
    prop: 'sportId',
    event: 'change'
  },
  props: {
    sportId: {
      type: String,
      default: ''
    },
    sportList: {
      type: Array,
      default: () => []
    },
    // 埋点类型
    trackType: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick(sportId, sportName) {
      this.$emit('change', sportId, sportName)
      window.mstrace(`Home_${this.trackType}${sportName.replace(/\s/g, '')}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.snap-nav-item {
  padding: 14px 0;
  margin-right: 20px;
  font-size: 14px;
  line-height: 1;

  &.active {
    font-size: 16px;
    font-weight: bold;
  }
}

[data-mode="light"] {
  .snap-nav-item {
    color: #333;

    &.active {
      color: #000;
    }
  }
}
</style>
